// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__9_LSM","left":"InfoRow_left__1zFAI"};